<template lang="pug">
div 
    //- modal(v-show="IsDocumentPDF",:titulo="this.DocumentSelect.category" bindClass="col-md-10 col-sm-12" , @close="IsDocumentPDF=false")#DocumentoTablaDetalle
    //-     div(slot='body')          
    //-         div(style="background-color: gray; ")
    //-               div
    //- modal(v-show="IsDocumentPDF")
    //-     div(slot='body')  
    //-         formatpdf(:tableInfoDetalis="tableInfoDetalis" :IdEnterprise="IdEnterprise" :DocumentSelect="DocumentSelect")
    vue-html2pdf(
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="750"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="letter"
        pdf-orientation="landscape"
        pdf-content-width="800px"
        pdf-unit="in" 
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf")
            section( slot="pdf-content")
                section( class="pdf-item")
                    formatpdf(:tableInfoDetalis="tableInfoDetalis" :IdEnterprise="IdEnterprise" :DocumentSelect="DocumentSelect")
                section( class="pdf-item" v-for="item of tableInfoDetalis.filter(b=> b.answer=='NO')") 
                    span(class="break-page") 
                    anexoPdf(:item="item"  :DocumentSelect="DocumentSelect")
    modal(v-show="IsShowQuestions",:titulo="'Preguntas :' + this.DocumentSelect.category" bindClass="col-md-7 col-sm-12" , @close="IsShowQuestions=false")#DocumentoTablaDetalle
        div(slot='body')     
            table.table.table-sm.table-borderedonlytable
                thead.bg-table.text-white
                    th Modificar
                    th(v-if="tableHeadDetalis.length && item!='idDocumentDetails' && item!='idDocument' && item!='update'", v-for="item in tableHeadDetalis") {{item}}                     
                tbody.bg-white(name="table-fade", is="transition-group") 
                    tr(v-if="tableInfoDetalis.length", v-for="(row,index) in tableInfoDetalis", :key="index") 
                        td
                            button.btn.btn-sm(@click="row.update=row.update==0?1:0")  
                                i(v-if="row.update==0").fa.fa-edit                                  
                                i(v-else, @click="Update_answer(row)").fa.fa-floppy-o                                 
                        td(v-if="column!='idDocumentDetails' && column!='idDocument'",v-for="(value,column) in  row")  
                            div(v-if="column=='img'")    
                               button.btn.btn-sm.btn-warning(v-if="value!=''", @click="selectImg.img=value; selectImg.question=row.question; IsShowImg=true")
                                    i.fa.fa-picture-o
                            div(v-else-if="column=='answer'") 
                                div(v-if="row.update == 0") {{value}}  
                                select.form-control.form-control-sm(v-else, @change="v=> row.answer=v.target.value"   :disabled="row.update==0 ? true:false")
                                            option(value='SI') SI
                                            option(value='NO') NO   
                                            option(value='NA') NA      
                            div(v-if="column!='img' && column!='answer'  && column!='update'") {{value}} 
            button.btn.btn-sm.btn-success(@click="exportar('DocumentoTablaDetalle','Documentos')") Exportar 
                            span.fa.fa-file-excel-o
    modal(v-show="IsShowImg",:titulo="'Imagen : ' + selectImg.question" bindClass="col-md-7 col-sm-12" , @close="IsShowImg=false")
        div(slot='body') 
             img(:src="'data:image/png;base64,' + selectImg.img")     
    v-dialog(v-model="modalDocument" width="800"   )
        formatDocument(v-if="modalDocument" :idDocument.sync="selectDocument.id" :numberDocument.sync="selectDocument.numberDocument" :category.sync="selectDocument.category" @close="modalDocument=false;List_Info()")
    v-container(fluid)
        v-card            
            v-card-title
                h4 {{InfoSelect.Name}}
            div(v-show="false") {{IdDocType_}} 
            v-card-title INFORMES
                v-spacer
                v-text-field(v-model="search" label="Busqueda...." class="mx-4" append-icon="mdi-magnify")        
                v-btn(color="success" @click="exportar('DocumentoTabla',InfoSelect.Name)") Exportar
                    i.fa.fa-plus-excel-o      
            v-data-table#DocumentoTabla(      
                :headers="tableHeadTest"                 
                :items="tableInfo"
                :items-per-page="50"
                class="elevation-1 table1"
                :search="search"   ) 
                template( v-slot:item.sendEmail="{ item }") 
                    td(style="width:150px") 
                        v-icon(v-if="typeAccount==1", @click="Delete_Lista(item.idDocument,item.numero)"                            
                            style="margin:2px!important"
                            color="red"
                        ) mdi-delete 
                        v-icon(
                             
                            style="margin:2px!important"
                            color="green"
                            @click="selectDocument.id=item.idDocument;selectDocument.numberDocument=item.numero; selectDocument.category=item.category;  modalDocument=true"
                        ) mdi-pencil                       
                        v-icon(
                             
                            style="margin:2px!important"
                            @click="DocumentSelect=item; IsDocumentPDF=true; List_Info_Detalis_PDF()"
                            color="primary"
                        ) mdi-file-pdf
                        v-icon(
                             
                            style="margin:2px!important"
                            @click="DocumentSelect=item; IsShowQuestions=true; List_Info_Detalis()"
                            color="orange"
                        ) mdi-comment-question-outline
                template( v-slot:item.img_1="{ item }") 
                    v-btn(fab x-small color="yellow" v-if="item.img_1!=''", @click="selectImg.img=item.img_1; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        v-icon  mdi-image-filter
                template( v-slot:item.img_2="{ item }") 
                    v-btn(fab x-small color="yellow" v-if="item.img_2!=''", @click="selectImg.img=item.img_2; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        v-icon  mdi-image-filter
                template( v-slot:item.img_3="{ item }") 
                    v-btn(fab x-small color="yellow" v-if="item.img_3!=''", @click="selectImg.img=item.img_3; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        v-icon  mdi-image-filter
                template( v-slot:item.img_4="{ item }") 
                    v-btn(fab x-small color="yellow" v-if="item.img_4!=''", @click="selectImg.img=item.img_4; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        v-icon  mdi-image-filter
                template( v-slot:item.img_5="{ item }") 
                    v-btn(fab x-small color="yellow" v-if="item.img_5!=''", @click="selectImg.img=item.img_5; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        v-icon  mdi-image-filter
                    //--template( v-slot:body="{ items }") 
                        //- tr(v-for="item in items")
                        //-     td(v-if="row!='idDocument' && row!='errorSendEmail'" v-for="row in Object.keys(item)")
                        //-         div(v-if="item[row]!=null && item[row]!='' && item[row].length>1500") 
                        //-             .form-row
                        //-                 .col-md-12
                        //-                     button.btn.btn-sm.btn-warning(v-if="item[row]!=''", @click="selectImg.img=item[row]; selectImg.question= 'numero -> ' + item.numero; IsShowImg=true")
                        //-                         i.fa.fa-picture-o
                        //-         div(v-else) 
                        //-             .form-row(v-if="row=='sendEmail' && item[row]=='1'") 
                        //-                 .col-md-12
                        //-                     button.btn.btn-default(@click="SendEmail(item.idDocument)")
                        //-                         i(style="color : gray").fa.fa-envelope    
                        //-             .form-row(v-else-if="row=='questions'") 
                        //-                 .col-md-3
                        //-                     button.btn.btn-default(@click="DocumentSelect=item; IsDocumentPDF=true; List_Info_Detalis_PDF() ")
                        //-                         i(style="color : red;").fa.fa-file-pdf-o
                        //-                 .col-md-3
                        //-                     button.btn.btn-default(@click="DocumentSelect=item; IsShowQuestions=true; List_Info_Detalis() ")
                        //-                         i(style="color : green;").fa.fa-question-circle
                        //-                 .col-md-3
                        //-                     button.btn.btn-default(v-if="typeAccount==1", @click="Delete_Lista(item.idDocument,item.numero)")
                        //-                         i(style="color : orange;").fa.fa-trash-o
                        //-             .form-row(v-else)
                        //-                 .col-md-12
                        //-                     |  {{item[row]}}

                                     

</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import modal from "../../../../complementos/modal.vue" 
import model from "../../../../models/docQuestionsCategory.js" 
import formatpdf from "./formatPdf"
import anexoPdf from "./anexoPdf"
import formatDocument from "./formDocument.vue"
import exportExcel from '../../../..//tools/exportExcel.js'
import { EventBus } from "../../../../complementos/event-bus.js";
export default {
    props:{   
        InfoSelect:Object, 
        apiWeb:Object, 
    },  
    data(){
        return{ 
            search:'',
            selectDocument:{id:0,numberDocument:1,category:''},
            modalDocument:false,
            pathApi:'Report/',
            IsShowQuestions:false, 
            IsShowImg:false, 
            IdEnterprise:this.$info.idEnterprise,
            IsDocumentPDF:false,
            tableHeadTest:[],
            typeAccount:0,
            selectImg:{img:'',question:''},
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            DocumentSelect:{},
            alturapdf:0,
            IdDocTypeOld_:0,
            tableInfo:[],
            tableHead:{},
            tableHeadPdf:{},
            tableInfoDetalis:[],
            tableHeadDetalis:{}
        }
    },
    created(){
         this.typeAccount=this.$info.typeAccount
    },
    components:{
        modal,
        VueHtml2pdf,
        formatpdf,
        anexoPdf ,
        formatDocument 
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info()  
                            this.$emit("update:IsShowModal",val)
                        }
        },
        IdDocType_ :{
                        get(){
                            if(this.IdDocTypeOld_!=this.InfoSelect.IdDocType){
                                this.IdDocTypeOld_=this.InfoSelect.IdDocType
                                this.List_Info()                                
                            }                                
                            return this.InfoSelect.IdDocType
                        },
                        set(val){ 
                           
                        }
        } 
    }, 
    methods:{
        showMSGerror(msgError){
            this.$msgbox.show(msgError,"OK")     
        },
        ValidateValor(v){
            console.log(v)
        },
        generateReport (name) {
             
            this.$refs.html2Pdf.htmlToPdfOptions= { margin:       [5, 0, 30, 0],  filename: name + '.pdf',pageBreak: { mode: 'css', after:'.break-page'}}
            this.$refs.html2Pdf.generatePdf()
        },
        IsEdit(val){
            val=val==0 ? 1:0;
            console.log(val)
        }
        ,
        SendEmail(id){               
            this.apiWeb.get(this.pathApi + "SendEmail/"+ id,"")
                    .then(result=>{
                                if(result.status==0){
                                   this.$msgbox.show("Enviado","Mensaje")   
                                   this.List_Info()                        
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update_answer(item){
            console.log(item.update)
            if(item.update==1)
            {
                this.$msgbox.confirm("Esta Seguro de Actualizar la respuesta?","Aviso")
                        .then(r=>{
                            if(r){
                                    this.apiWeb.get("DocumentDetails/DocumentDetails_Update/"+ item.idDocumentDetails +"/"+ item.answer,"")
                .then(result=>{
                                if(result.status==0){
                                    this.$msgbox.show("Valor Modificado","OK")                             
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                            })
                            .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")}) 
                                        }
                                    })
            } 
            
        }, 
        Delete_Lista(id,n){
                this.$msgbox.confirm("Esta Seguro de eliminar el documento : " + n + " ?","Aviso")
                            .then(r=>{
                                if(r){
                                       this.apiWeb.get(this.pathApi + "DeleteDocument/"+ id,"")
                    .then(result=>{
                                    if(result.status==0){
                                        this.List_Info();                               
                                                                    
                                    }
                                    else{
                                        this.$msgbox.show(result.message,"Error nivel 1")
                                    }
                                })
                                .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")}) 
                                            }
                                        })
        },
        List_Info(){               
            this.apiWeb.get(this.pathApi + "ReportDocument/"+ this.IdDocType_,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableHeadTest=[] 
                                    this.tableInfo=JSON.parse(JSON.stringify(result.value))  
                                    if( this.tableInfo.length>0)
                                    {
                                       this.tableHead=Object.keys(this.tableInfo[0])    
                                       console.log(this.tableHead) 
                                       var countImg=1;
                                       this.tableHead.forEach(element => {
                                        
                                        if(element=='questions')
                                                this.tableHeadTest.push({text: 'Preguntas', value:element, class:"tdTotal"})    
                                        else if(element=='sendEmail')
                                                this.tableHeadTest.push({text: 'Acciones', value:element, class:"tdTotal"})  
                                        else if(element.indexOf("imG_")==0){
                                            this.tableHeadTest.push({text:element.replace('imG_',''), value:'img_'+countImg.toString(), class:"tdTotal"}) 
                                            this.tableInfo.forEach(objeto => {
                                                    objeto['img_'+countImg] = objeto[element];
                                                    delete objeto[element]
                                                });
                                            countImg++;
                                        }
                                                   
                                        else if(element!='idDocument' && element!='errorSendEmail'){
                                                this.tableHeadTest.push({text: element.capitalize(), value:element, class:"tdTotal"})
                                        }


                                       
                                       });

                                       this.tableHead=Object.keys(this.tableInfo[0])    
                                       console.log(this.tableHead) 
                                      
                                       
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Info_Detalis(){               
            this.apiWeb.get(this.pathApi + "ReportDocumentDetails/"+ this.DocumentSelect.idDocument,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfoDetalis=JSON.parse(JSON.stringify(result.value))  
                                    
                                    if( this.tableInfoDetalis.length>0)
                                    {
                                    // this.tableInfoDetalis.forEach(element => {
                                    //         element.update=0
                                    //     });
                                       this.tableHeadDetalis=Object.keys(this.tableInfoDetalis[0])         
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Info_Detalis_PDF(){               
            this.tableHeadPdf=Object.keys(this.DocumentSelect)    
            this.apiWeb.get(this.pathApi + "ReportDocumentDetails/"+ this.DocumentSelect.idDocument,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfoDetalis=JSON.parse(JSON.stringify(result.value))  
                                    
                                    if( this.tableInfoDetalis.length>0)
                                    {
                                    // this.tableInfoDetalis.forEach(element => {
                                    //         element.update=0
                                    //     });
                                       this.tableHeadDetalis=Object.keys(this.tableInfoDetalis[0])  
                                       this.generateReport(this.DocumentSelect.category + '_'+this.DocumentSelect.numero)       
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        exportar(tabla,title){ 
                            EventBus.$emit("loading", true)
                            exportExcel.exportToExcel(title,this.tableInfo) 
                            EventBus.$emit("loading", false)
                        },
        
    }

    
}
</script>
<style>
.break-page {break-after: page;}  

.tdColumn {
    background-color: var(--tdFirst)!important; 
    color:white!important;
    
  } 
  .tdValue{
      background-color: var(--td)!important; 
      color:black;
  }
  .tdTotal{
      background-color: var(--tdLast)!important; 
      font-weight: bold;
      color:white!important;
  }
  
  .table1{
      background-color: var(--Fondo2)!important;
      color: white!important;
  }
  .table1 tbody tr td   {
      background-color: white; 
      color:black;
  }

  .table1 tbody tr td:first-child  {
    background-color: var(--tdLast)!important; 
    font-weight: bold;
    color:white!important;
  }
</style>